import tokens from "../tokens";

// The steerage palette (see ../tokens.ts), mapped onto the names the Material
// Dashboard template's components ask for. `info` is the colour most buttons
// use (MDButton color="info"), so it carries the indigo accent too.
const { colors: c } = tokens;

const colors = {
  background: {
    default: c.bg,
  },

  text: {
    main: c.subtle,
    focus: c.subtle,
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: c.primary,
    focus: c.primaryDark,
  },

  secondary: {
    main: "#64748b",
    focus: c.subtle,
  },

  info: {
    main: c.primary,
    focus: c.primaryDark,
  },

  success: {
    main: c.success,
    focus: "#15803d",
  },

  warning: {
    main: c.warning,
    focus: "#a16207",
  },

  error: {
    main: c.danger,
    focus: "#b91c1c",
  },

  light: {
    main: "#f1f5f9",
    focus: c.border,
  },

  dark: {
    main: c.text,
    focus: c.text,
  },

  // Tailwind slate, so greys match the steerage app's.
  grey: {
    100: "#f1f5f9",
    200: c.border,
    300: c.borderStrong,
    400: c.muted,
    500: "#64748b",
    600: c.subtle,
    700: c.secondary,
    800: "#1e293b",
    900: c.text,
  },

  // The template draws buttons as gradients; these are near-flat so they read
  // as the steerage app's solid buttons.
  gradients: {
    primary: {
      main: c.primaryLight,
      state: c.primary,
    },

    secondary: {
      main: "#64748b",
      state: c.subtle,
    },

    info: {
      main: c.primaryLight,
      state: c.primary,
    },

    success: {
      main: c.success,
      state: "#15803d",
    },

    warning: {
      main: "#eab308",
      state: c.warning,
    },

    error: {
      main: "#ef4444",
      state: c.danger,
    },

    light: {
      main: "#f1f5f9",
      state: c.border,
    },

    dark: {
      main: c.secondary,
      state: c.text,
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: { background: c.primarySoft, text: c.primaryDark },
    secondary: { background: "#f1f5f9", text: c.subtle },
    info: { background: c.primarySoft, text: c.primaryDark },
    success: { background: "#dcfce7", text: "#15803d" },
    warning: { background: "#fef9c3", text: "#a16207" },
    error: { background: "#fee2e2", text: "#b91c1c" },
    light: { background: "#ffffff", text: c.muted },
    dark: { background: c.border, text: c.text },
  },

  // Soft, near-neutral shadows under coloured elements, as in steerage.
  coloredShadows: {
    primary: c.primary,
    secondary: "#64748b",
    info: c.primary,
    success: c.success,
    warning: c.warning,
    error: c.danger,
    light: c.muted,
    dark: c.secondary,
  },

  inputBorderColor: c.borderStrong,

  tabs: {
    indicator: { boxShadow: c.border },
  },

  action: {
    hover: c.primarySoft,
    selected: c.primarySelected,
    focus: c.primaryHover,
    disabled: c.muted,
  }
};

export default colors;
